module.exports = __webpack_public_path__ + "static/media/industriales_unidos.49353212.jpeg";